import { Client } from '../api-client';
import { AddVideoRatingPayload } from '../hooks/lecture-leave/useAddVideoRating';

const addVideoRating = () => 'v1/ratings/add-rating';

const checkUnleashFeature = () => 'user-experience/unleash/check-feature';

export const addVideoRatingFetcher = (payload: AddVideoRatingPayload) => {
  return Client.post(addVideoRating(), payload).then((res) => res?.data);
};

export const checkUnleashFeatureFetcher = (payload: { featureName: string[] }) => {
  return Client.post(checkUnleashFeature(), payload).then((res) => res?.data);
};
